import { render, staticRenderFns } from "./eAristoLoadingPlaceholder.vue?vue&type=template&id=4b7e0e61&scoped=true"
var script = {}
import style0 from "./eAristoLoadingPlaceholder.vue?vue&type=style&index=0&id=4b7e0e61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e0e61",
  null
  
)

export default component.exports